export default "__VITE_ASSET__61c7e28a__"